module.exports = __webpack_public_path__ + "img/al_grey.f315c82e.svg";